import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 4L9 14",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14 9L4 9",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AddIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "add",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})